import { render } from "./index.vue?vue&type=template&id=166283cb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=166283cb&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166283cb"]])

export default __exports__